import { RelevancyCardType } from '../types';

const components = {
  [RelevancyCardType.EIDOS_CONTENT]: 'EidosComponent',
  [RelevancyCardType.ARTICLE]: 'ArticleComponent',
  [RelevancyCardType.VIDEO]: 'VideoComponent',
  [RelevancyCardType.GAMING]: 'GamingComponent',
  [RelevancyCardType.HEAD_TO_HEAD]: 'HeadToHeadComponent',
  [RelevancyCardType.FORM_GUIDE]: 'FormGuideComponent',
  [RelevancyCardType.TEAM_OF_THE_WEEK]: 'TotwComponent',
  [RelevancyCardType.PLAYERS_TO_WATCH]: 'PtwComponent',
  [RelevancyCardType.QUIZARENA]: 'QuizComponent',
  // [RelevancyCardType.HIGHLIGHT_GROUP]: 'HighlightGroupComponent',
  [RelevancyCardType.SKILLS_GROUP_EIDOS]: 'SkillsComponent',
  [RelevancyCardType.WEB_LINK]: 'WebLinkComponent',
  [RelevancyCardType.PHOTO_GALLERY]: 'PhotogalleryComponent',
  [RelevancyCardType.PERFORMANCE_ZONE]: 'BarometerComponent',
  [RelevancyCardType.LIVE_AUDIO]: 'AudioComponent',
  [RelevancyCardType.PODCAST]: 'PodcastComponent',
  [RelevancyCardType.TOP_SCORER]: 'TopScorerComponent',
  [RelevancyCardType.DOCUMENT]: 'DocumentComponent',
};

export default components;
